//工具函数
export default {
    //获取语言
    getNowLang() {
        return localStorage.getItem('lang');
    },
    //设置语言
    setLang(lang) {
        localStorage.setItem('lang', lang);
    },
    //获取router
    getRouter() {
        let routes=localStorage.getItem('routes')
        return JSON.parse(routes);
    },
    //设置router
    setRouter(routes) {
      
        localStorage.setItem('routes', JSON.stringify(routes));
    },
    //token
    setToken(name,token){
        localStorage.setItem(name, token, 1800000);
    },
    getToken() {
        return '2yaz5478YwcXEAKc30n8fpKtZ3jcxWLTrzVmRxH47RabW45cccpR5cF8hkac';
    },
}